const cards = {
  resource: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    pt: 3,
    px: 4,
    pb: 4,
    mb: 4,
    backgroundColor: 'white',
    boxShadow: '0px 2px 35px rgba(28, 34, 38, 0.15)',
    width: '100%',
  },
  success: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: ['center'],
    width: '100%',
    padding: '35px 50px',
    backgroundColor: 'white',
    boxShadow: '4px 4px 8px rgba(0, 0, 0, 0.25)',
    maxWidth: 744,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: ['flex-start'],
    width: '100%',
    pt: 6,
    px: [4, 7],
    pb: 4,
    mb: 2,
    backgroundColor: 'white',
    boxShadow: '4px 4px 8px rgba(0, 0, 0, 0.25)',
    maxWidth: 744,
  },
  feature: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    p: 5,
    mr: 5,
    width: 264,
    backgroundColor: 'white',
    boxShadow: '0px 2px 35px rgba(28, 34, 38, 0.15)',
    transition: '.25s',
    '&:hover': {
      boxShadow: '0px 2px 35px rgba(28, 34, 38, 0.25)',
    },
  },
  recommendedResource: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    height: 176,
    width: '100%',
    maxWidth: 552,
    p: 5,
    mr: 5,
    mb: 5,
    backgroundColor: 'white',
    boxShadow: '0px 2px 35px rgba(28, 34, 38, 0.15)',
    '&:hover': {
      boxShadow: '0px 2px 35px rgba(28, 34, 38, 0.25)',
      cursor: 'pointer',
    },
  },
  peerStory: {
    flex: '0 0 80%',
    flexDirection: 'column',
    minWidth: ['unset', 320, 320],
    maxWidth: 547,
    mx: 3,
    bg: 'white',
    backgroundColor: 'white',
    boxShadow: '0px 2px 35px rgba(28, 34, 38, 0.15)',
    '&:first-of-type': {
      ml: [null, null, null, 0],
    },
    '&:hover': {
      boxShadow: '0px 2px 35px rgba(28, 34, 38, 0.25)',
      cursor: 'pointer',
    },
  },
  newContent: {
    flex: '0 0 80%',
    flexDirection: 'column',
    minWidth: 320,
    maxWidth: 396,
    maxHeight: 300,
    bg: 'white',
    backgroundColor: 'white',
    boxShadow: '0px 2px 35px rgba(28, 34, 38, 0.15)',
    '&:hover': {
      boxShadow: '0px 2px 35px rgba(28, 34, 38, 0.25)',
      cursor: 'pointer',
    },
  },
  question: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    mt: 7,
    mx: 110,
    p: 7,
    mb: 4,
    backgroundColor: 'white',
    boxShadow: '0px 2px 35px rgba(28, 34, 38, 0.15)',
    width: '100%',
  },
  services: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    maxWidth: 552,
    pt: 5,
    pr: 5,
    pb: 5,
    mr: 5,
    mb: 5,
  },
  offering: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    maxWidth: 315,
    color: 'darkGray',
    pt: 5,
    pr: 5,
    pb: 5,
    mr: 5,
    mb: 5,
  },
  pricing: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: 'paleSilver',
    pt: 7,
    px: 5,
    pb: 4,
    mb: 4,
    width: 357,
    height: 634,
  },
  strategyBuilderSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    maxWidth: 1128,
    my: 4,
    backgroundColor: 'white',
    boxShadow: '0px 2px 35px rgba(28, 34, 38, 0.15)',
  },
  learningCenterResource: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    border: '1px solid darkGray',
    '&:hover': {
      backgroundColor: 'forest',
      cursor: 'pointer',
      borderColor: 'citron',
      color: 'white',
      hr: {
        borderColor: 'citron',
      },
    },
  },
}

export default cards
